import {
  RouteComponentProps,
  RouteProps,
  Route,
  useLocation,
} from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import PageLoader from 'components/PageLoader';
import ErrorBoundary from 'components/ErrorBoundary';
import { Breadcrumb, useLayoutContext } from 'contexts/LayoutContext';
import { useEffect, useRef } from 'react';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';

const RestrictedRoute: React.FC<
  RouteProps & {
    component: React.FC<RouteComponentProps>;
    useErrorBoundary?: boolean;
    breadcrumbs?: Array<Breadcrumb>;
    icon?: OverridableComponent<SvgIconTypeMap<object>>;
  }
> = ({ component, useErrorBoundary, breadcrumbs, icon, path, ...rest }) => {
  const { setBreadcrumbs, setPageIcon } = useLayoutContext();
  const { pathname } = useLocation();
  const prevPathRef = useRef<string | null>(null);

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <PageLoader />,
  });

  useEffect(() => {
    const prevPath = prevPathRef.current;
    if (prevPath !== pathname) {
      setBreadcrumbs(breadcrumbs ?? []);
      setPageIcon(icon ?? null);
    }
    prevPathRef.current = pathname;
  }, [breadcrumbs, icon]);

  return (
    <Route
      render={(routeProps) =>
        useErrorBoundary ? (
          <ErrorBoundary loader={<PageLoader />}>
            <Component {...routeProps} />
          </ErrorBoundary>
        ) : (
          <Component {...routeProps} />
        )
      }
      {...rest}
    />
  );
};

export default RestrictedRoute;
